import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactToPrint from "react-to-print";
import { setlocalChalanDetail } from "../../storeSlices/localChalanSlice";
// import "./chalan.css";

function ChalanRasid(props) {
  console.log(props);
  const dispatch = useDispatch();
  let componentRef = useRef();
  const navigate = useNavigate();
  const profileDetails = useSelector((state) => state.dataReducer.profile);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  return (
    <div
      className="bill-container "
      id="bill-template"
      style={{ margin: "auto", padding: "20px", border: "none" }}
    >
      <div
        ref={(el) => (componentRef = el)}
        className="bill-container "
        id="bill-template"
        style={{ margin: "auto", padding: "20px" }}
      >
        <table style={{ margin: "auto" }}>
          <tr>
            <td
              colSpan="8"
              style={{ textAlign: "center", backgroundColor: "#d8d8d8" }}
            >
              <h2 style={{ fontSize: "40px", textShadow: "3px 3px slategray" }}>
                {props.chalan.billed_to}
              </h2>
              {/* <h2>SHREE CEMENET LIMITED</h2>
        <p>IMPORT PORT ADDRESS : MUNDRA SEZ PORT, MUNDAR-324567,GUJRAT</p>*/}
              <h3>DELIVERY CHALLAN</h3>
            </td>
          </tr>

          <tr>
            <td style={{ border: "none" }}>
              <b>GST NO.</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.gst_no}</td>
            <td style={{ border: "none" }}>
              <b>PAN NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.pan_no}</td>
            <td
              style={{
                borderBottom: "none",
                borderRight: "none",
                borderTop: "none",
              }}
            >
              <b>CIN NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.cin_no}</td>
            <td colSpan="2" style={{ border: "none" }}></td>
          </tr>

          <tr style={{ border: "none" }}>
            <td style={{ border: "none" }}>
              <b>CHALLAN NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.challan_number}</td>
            <td style={{ border: "none" }}>
              <b>DATE</b>
            </td>
            <td style={{ border: "none" }}>{formatDate(props.chalan.date)}</td>
            <td
              style={{
                borderBottom: "none",
                borderRight: "none",
                borderTop: "none",
              }}
            >
              <b>GR NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.gr_no}</td>
            <td style={{ border: "none" }}>
              <b>GR DATE</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.gr_date}</td>
          </tr>

          <tr>
            <td style={{ borderRight: "none", borderBottom: "none" }}>
              <b>Freight Mode</b>
            </td>
            <td
              colSpan="3"
              style={{ borderLeft: "none", borderBottom: "none" }}
            >
              {props.chalan.freight_mode}{" "}
            </td>
            <td style={{ borderRight: "none", borderBottom: "none" }}>
              <b>E-Way Bill No</b>
            </td>
            <td
              colSpan="3"
              style={{ borderLeft: "none", borderBottom: "none" }}
            >
              {props.chalan.e_way_bill_no}{" "}
            </td>
          </tr>

          <tr>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Freight Type</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.freight_type}
            </td>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Vessel Name</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.vessel_name}
            </td>
          </tr>

          <tr>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Transporter Name</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.transporter}
            </td>
            {/* <p>SHREE MAHAAVEER TRANSPORT COMPANY</p> */}
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Exporter Name</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.exporter_name}
            </td>
          </tr>

          <tr>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Truck Number</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.truck_no}
            </td>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Bill of Entry No.</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.entery_bill_no}
            </td>
          </tr>

          <tr>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Invoice No.</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.invoice_no}
            </td>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>Invoice Date</b>
            </td>
            <td
              colSpan="3"
              style={{
                borderLeft: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              {props.chalan.invoice_date}
            </td>
          </tr>

          <tr>
            <td style={{ borderRight: "none", borderBottom: "none" }}>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <b>Billed To:</b>
              ) : (
                <b>Billed From:</b>
              )}
              {/* <b>Billed From</b> */}
            </td>
            <td
              colSpan="3"
              style={{ borderLeft: "none", borderBottom: "none" }}
            >
              <p>{props.chalan.billed_to}</p>
              <p>{props.chalan.billed_to_address}</p>
            </td>

            <td style={{ borderRight: "none", borderBottom: "none" }}>
              {profileDetails &&
              profileDetails.pro &&
              profileDetails.pro["name"] ===
                "SHREE MAHAVEER TRANSPORT COMPANY" ? (
                <b>Delivery To:</b>
              ) : (
                <b>Billed and Delivery To:</b>
              )}
              {/* <b>Billed and Delivery To</b> */}
            </td>
            <td
              colSpan="3"
              style={{ borderLeft: "none", borderBottom: "none" }}
            >
              <p> {props.chalan.delivery_to}</p>
              <p>{props.chalan.delivery_to_address}</p>
            </td>
          </tr>

          <tr>
            <td style={{ border: "none" }}>
              <b>State</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.billed_state}</td>
            <td style={{ border: "none" }}>
              <b>Code</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.billed_code}</td>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>State</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.delivery_state}</td>
            <td style={{ border: "none" }}>
              <b>Code</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.delivery_code}</td>
          </tr>

          <tr>
            <td style={{ border: "none" }}>
              <b>GST NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.billed_gst}</td>
            <td style={{ border: "none" }}>
              <b>PAN NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.billed_pan}</td>
            <td
              style={{
                borderRight: "none",
                borderBottom: "none",
                borderTop: "none",
              }}
            >
              <b>GST NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.delivery_gst}</td>
            <td style={{ border: "none" }}>
              <b>PAN NO</b>
            </td>
            <td style={{ border: "none" }}>{props.chalan.delivery_pan}</td>
          </tr>

          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th colSpan="3">Description of Goods </th>
            <th>HSN Code </th>
            <th>Qty</th>
            <th>UOM</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>

          <tr>
            <td colSpan="3" style={{ textAlign: "center" }}>
              {" "}
              {props.chalan.description_of_goods}
            </td>
            <td style={{ textAlign: "center" }}>{props.chalan.hsn_code}</td>
            <td style={{ textAlign: "center" }}>{props.chalan.qty}</td>
            <td style={{ textAlign: "center" }}>{props.chalan.uom}</td>
            <td style={{ textAlign: "center" }}>{props.chalan.rate}</td>
            <td style={{ textAlign: "right" }}>{props.chalan.amount}</td>
          </tr>

          <tr style={{ backgroundColor: "#f2f2f2" }}>
            <td colSpan="3" style={{ textAlign: "center" }}>
              (sgst*igst*cess*cessNonAd){" "}
            </td>
            <td colSpan="3" style={{ textAlign: "center" }}>
              {props.chalan.sgstRate}*{props.chalan.igstRate}*
              {props.chalan.cessRate}*{props.chalan.cessNonAdvol}
            </td>
            {/* <td></td>
                <td></td> */}
            <td style={{ textAlign: "right" }}>Total challan Amount</td>
            <td style={{ textAlign: "right" }}>
              {props.chalan.total_challan_amount}
            </td>
          </tr>

          <tr>
            <td colSpan="8">
              <p style={{ textAlign: "right" }}>
                <b>FOR </b> {props.chalan.billed_to}
              </p>
              {/* <div className="bLeft">
              <p>Termss & condition</p>
              <ol>
                <li> Subject to Beawar (Rajasthan) Jurisdiction.</li>
              </ol>
            </div> */}
              <br />
              <p style={{ textAlign: "right" }}>
                <b>AUTHORISED SIGNATORY</b>
              </p>{" "}
            </td>
          </tr>

          <tr style={{ backgroundColor: "#d8d8d8" }}>
            <td colSpan="8">
              <address>
                Regd. / Work Off. :{" "}
                {profileDetails && profileDetails.pro
                  ? profileDetails.pro["address"]
                  : "---"}{" "}
                Tel :{" "}
                {profileDetails?.pro
                  ? profileDetails.pro.phone_no ?? "---"
                  : "---"}
              </address>
            </td>
          </tr>
          {/* <button
            onClick={(e) => {
              e.preventDefault();

              var printContents =
                document.getElementById("bill-template").innerHTML;
              var originalContents = document.body.innerHTML;

              document.body.innerHTML = printContents;

              window.print();

              document.body.innerHTML = originalContents;
            }}
          >
            Print
          </button> */}
        </table>
      </div>
      <div style={{ textAlign: "Center" }}>
        <ReactToPrint
          trigger={() => <button>Print this out!</button>}
          content={() => componentRef}
        />
        <button onClick={props.handleClose2}>Close</button>
      </div>
    </div>
  );
}

export default ChalanRasid;
